// extracted by mini-css-extract-plugin
export default {"heading":"functionSetup_heading__aQ6k1","headerContainer":"functionSetup_headerContainer__ZW7nt"};